module.exports = __webpack_public_path__ + "media/src/images/icons/credit_cards/mastercard-4668949e37c23ba9b77aea7465e43dfd.png";